import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Observable, Subject, throwError } from 'rxjs';

import { IGetDispatchStatusPayload } from './vendorDashboard.model';
import {
  IAcceptOrRejectLegAssignmentPayLoad,
  ICurrentLocationResponseModel,
  IDispatchStatusResponseModel,
  IGetLegDetailsPayLoad,
  ILegCurrentStatusViewModel,
  ILegDetailsViewModel,
} from '../model/Vendor.model';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class VendorDashboardService {
  public closeLegDetailsPopUp: Subject<boolean> = new Subject();
  public $resetSelectedLegDetailListFromLegDetailsService: Subject<boolean> = new Subject();

  constructor(private httpClient: HttpClient) {}

  getAllActiveRequestData(businessUnitId: string, offset, limit) {
    const url = `${environment.apiUrl}/VendorDashboard/getAllActiveRequest/${businessUnitId}/${offset}/${limit}`;

    return this.httpClient.get(url)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  getLegAssignmentRequestById(vendorId: string): Observable<ILegDetailsViewModel[]> {
    const url = `${environment.apiUrl}/VendorDashboard/GetLegAssignmentRequestById/${vendorId}`;

    return this.httpClient.get<ILegDetailsViewModel[]>(url)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  getLegDetailsList(payLoad: IGetLegDetailsPayLoad): Observable<ILegDetailsViewModel[]> {
    const url = `${environment.apiUrl}/VendorDashboard/GetLegDetailsByIdAndType`;

    return this.httpClient.post<ILegDetailsViewModel[]>(url, payLoad)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  getDispatchStatusDetails(payLoad: IGetDispatchStatusPayload): Observable<IDispatchStatusResponseModel> {
    const url = `${environment.apiUrl}/VendorDashboard/GetDispatchStatus`;

    return this.httpClient.post<IDispatchStatusResponseModel>(url, payLoad)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  acceptOrRejectLegAssignmentRequest(payLoad: IAcceptOrRejectLegAssignmentPayLoad): Observable<boolean> {
    const url = `${environment.apiUrl}/VendorDashboard/AcceptOrRejectLegAssignmentRequest`;

    return this.httpClient.put<boolean>(url, payLoad)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  getActiveLegStatus(payLoad: IGetDispatchStatusPayload): Observable<ILegCurrentStatusViewModel[]> {
    const url = `${environment.apiUrl}/VendorDashboard/GetActiveLegStatus`;

    return this.httpClient.post<ILegCurrentStatusViewModel[]>(url, payLoad)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  getMembersLocationByFilter(payLoad: IGetDispatchStatusPayload): Observable<ICurrentLocationResponseModel[]> {
    const url = `${environment.apiHost}/Member/GetMembersLocationByVendorId`;

    return this.httpClient.post<ICurrentLocationResponseModel[]>(url, payLoad)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

}
